import {
    FETCH_COMMISSION_CONFIGURATIONS_REQUEST,
    FETCH_COMMISSION_CONFIGURATIONS_SUCCESS,
    FETCH_COMMISSION_CONFIGURATIONS_FAILURE,
    CREATE_COMMISSION_CONFIGURATION_REQUEST,
    CREATE_COMMISSION_CONFIGURATION_SUCCESS,
    CREATE_COMMISSION_CONFIGURATION_FAILURE,
    UPDATE_COMMISSION_CONFIGURATION_REQUEST,
    UPDATE_COMMISSION_CONFIGURATION_SUCCESS,
    UPDATE_COMMISSION_CONFIGURATION_FAILURE,
    DELETE_COMMISSION_CONFIGURATION_REQUEST,
    DELETE_COMMISSION_CONFIGURATION_SUCCESS,
    DELETE_COMMISSION_CONFIGURATION_FAILURE,
} from "../actions/types";

const initialState = {
    configurations: [],
    loading: false,
    error: null,
    message: "",
};

const agentCommissionReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case FETCH_COMMISSION_CONFIGURATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_COMMISSION_CONFIGURATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                configurations: Array.isArray(action.payload)
                    ? action.payload
                    : [],
                error: null,
            };

        case FETCH_COMMISSION_CONFIGURATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case CREATE_COMMISSION_CONFIGURATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case CREATE_COMMISSION_CONFIGURATION_SUCCESS:
            return {
                ...state,
                loading: false,
                configurations: [
                    ...state.configurations,
                    action.payload,
                ],
                error: null,
                message:
                    "Agent commission configuration created successfully.",
            };

        case CREATE_COMMISSION_CONFIGURATION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case UPDATE_COMMISSION_CONFIGURATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case UPDATE_COMMISSION_CONFIGURATION_SUCCESS:
            return {
                ...state,
                loading: false,
                configurations: state.configurations.map(
                    (configuration) =>
                        configuration.configuration_id ===
                        action.payload.configuration_id
                            ? action.payload
                            : configuration
                ),
                error: null,
                message:
                    "Agent commission configuration updated successfully.",
            };

        case UPDATE_COMMISSION_CONFIGURATION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case DELETE_COMMISSION_CONFIGURATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case DELETE_COMMISSION_CONFIGURATION_SUCCESS:
            return {
                ...state,
                loading: false,
                configurations: state.configurations.filter(
                    (configuration) =>
                        configuration.configuration_id !==
                        action.payload
                ),
                error: null,
                message:
                    "Agent commission configuration deleted successfully.",
            };

        case DELETE_COMMISSION_CONFIGURATION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default agentCommissionReducer;